import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { FixingOrderRequestDataImpl } from "../model/impl/FixingOrderRequestDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

const SINGLE_OBJECT: boolean = false;
const ARRAY_OF_OBJECT: boolean = true;

const JAVA_OBJECT_NOTENCODABLE: boolean = false;
const OBJECT_ENCODABLE: boolean = false;

export class FixingOrderRequestDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: FixingOrderRequestDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.base != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(3),
        false,
        encodable.base,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCode != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clientCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.comment != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(5),
        false,
        encodable.comment,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.comment2 != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(6),
        false,
        encodable.comment2,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.externalClientReference != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.externalClientReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedCcy != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(12),
        false,
        encodable.fixedCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.markup != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(16),
        false,
        encodable.markup,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBase != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(17),
        false,
        encodable.nonBase,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(18),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.orderType != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(19),
        false,
        encodable.orderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.product != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(20),
        false,
        encodable.product,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.requestOrderType != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(21),
        false,
        encodable.requestOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.stpHold != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(24),
        false,
        encodable.stpHold,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyParameters != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(25),
        false,
        encodable.strategyParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroup != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(27),
        false,
        encodable.traderGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.tradingChannel != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(28),
        false,
        encodable.tradingChannel,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.isPrivateOrder != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(32),
        false,
        encodable.isPrivateOrder,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.useDefaultClientDataFg != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(36),
        false,
        encodable.useDefaultClientDataFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Object encoding*/
    if (encodable.clientContactIds != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(37),
        false,
        encodable.clientContactIds,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    /*Object encoding*/
    if (encodable.customValues != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(40),
        false,
        encodable.customValues,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    /*Object encoding*/
    if (encodable.markupType != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(41),
        false,
        encodable.markupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    /*Object encoding*/
    if (encodable.passthroughParameters != null) {
      this.baseEncoder.writeStartFid(45, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(45),
        false,
        encodable.passthroughParameters,
        streamout,
      );
      this.baseEncoder.writeEndFid(45, streamout);
    }
    /*Object encoding*/
    if (encodable.oboClient != null) {
      this.baseEncoder.writeStartFid(48, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(48),
        false,
        encodable.oboClient,
        streamout,
      );
      this.baseEncoder.writeEndFid(48, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(49, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(49),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(49, streamout);
    }
    /*Object encoding*/
    if (encodable.orderRef != null) {
      this.baseEncoder.writeStartFid(50, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(50),
        false,
        encodable.orderRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(50, streamout);
    }
    /*Object encoding*/
    if (encodable.autoForwardPricing != null) {
      this.baseEncoder.writeStartFid(51, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(51),
        false,
        encodable.autoForwardPricing,
        streamout,
      );
      this.baseEncoder.writeEndFid(51, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedAmount != null) {
      this.baseEncoder.writeStartFid(60, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(60),
        false,
        encodable.fixedAmount,
        streamout,
      );
      this.baseEncoder.writeEndFid(60, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDate != null) {
      this.baseEncoder.writeStartFid(61, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(61),
        true,
        encodable.fixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(61, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingSource != null) {
      this.baseEncoder.writeStartFid(62, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(62),
        false,
        encodable.fixingSource,
        streamout,
      );
      this.baseEncoder.writeEndFid(62, streamout);
    }
    /*Object encoding*/
    if (encodable.tenor != null) {
      this.baseEncoder.writeStartFid(63, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(63),
        false,
        encodable.tenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(63, streamout);
    }
    /*Object encoding*/
    if (encodable.valueDate != null) {
      this.baseEncoder.writeStartFid(64, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(64),
        true,
        encodable.valueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(64, streamout);
    }
    /*Object encoding*/
    if (encodable.clientIntent != null) {
      this.baseEncoder.writeStartFid(65, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(65),
        false,
        encodable.clientIntent,
        streamout,
      );
      this.baseEncoder.writeEndFid(65, streamout);
    }
    /*Object encoding*/
    if (encodable.swapFixedAmount != null) {
      this.baseEncoder.writeStartFid(66, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(66),
        false,
        encodable.swapFixedAmount,
        streamout,
      );
      this.baseEncoder.writeEndFid(66, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingTime != null) {
      this.baseEncoder.writeStartFid(67, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(67),
        true,
        encodable.fixingTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(67, streamout);
    }
    /*Object encoding*/
    if (encodable.swapTenor != null) {
      this.baseEncoder.writeStartFid(68, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(68),
        false,
        encodable.swapTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(68, streamout);
    }
    /*Object encoding*/
    if (encodable.swapValueDate != null) {
      this.baseEncoder.writeStartFid(69, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(69),
        true,
        encodable.swapValueDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(69, streamout);
    }
    /*Object encoding*/
    if (encodable.allocations != null) {
      this.baseEncoder.writeStartFid(70, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(70),
        false,
        encodable.allocations,
        streamout,
      );
      this.baseEncoder.writeEndFid(70, streamout);
    }
    /*Object encoding*/
    if (encodable.farAllocations != null) {
      this.baseEncoder.writeStartFid(71, streamout);
      this.baseEncoder.writeObject(
        true,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(71),
        false,
        encodable.farAllocations,
        streamout,
      );
      this.baseEncoder.writeEndFid(71, streamout);
    }

    /*Object encoding*/
    if (encodable.fwdNettingId != null) {
      this.baseEncoder.writeStartFid(72, streamout);
      this.baseEncoder.writeObject(
        SINGLE_OBJECT,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(72),
        JAVA_OBJECT_NOTENCODABLE,
        encodable.fwdNettingId,
        streamout,
      );
      this.baseEncoder.writeEndFid(72, streamout);
    }

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingOrderRequestDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,FixingOrderRequestDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [8, "java.lang.String"],
    [12, "java.lang.String"],
    [16, "java.lang.String"],
    [17, "java.lang.String"],
    [18, "java.lang.String"],
    [19, "com.bcdfx.model.OrderType"],
    [20, "com.bcdfx.model.Product"],
    [21, "com.bcdfx.model.RequestOrderType"],
    [24, "java.lang.Boolean"],
    [25, "com.bcdfx.model.StrategyParameter"],
    [27, "java.lang.String"],
    [28, "java.lang.String"],
    [32, "java.lang.Boolean"],
    [36, "java.lang.Boolean"],
    [37, "java.lang.Long"],
    [40, "com.bcdfx.model.CustomValue"],
    [41, "com.bcdfx.model.MarkUpType"],
    [45, "com.bcdfx.model.StrategyParameter"],
    [48, "java.lang.String"],
    [49, "java.lang.String"],
    [50, "java.lang.String"],
    [51, "java.lang.Boolean"],
    [60, "java.lang.String"],
    [61, "com.bcdfx.model.StandardDate"],
    [62, "java.lang.String"],
    [63, "com.bcdfx.model.Tenor"],
    [64, "com.bcdfx.model.StandardDate"],
    [65, "com.bcdfx.model.OrderIntent"],
    [66, "java.lang.String"],
    [67, "com.bcdfx.model.StandardTime"],
    [68, "com.bcdfx.model.Tenor"],
    [69, "com.bcdfx.model.StandardDate"],
    [70, "com.bcdfx.model.event.lifecycle.AllocationRequestDataImpl"],
    [71, "com.bcdfx.model.event.lifecycle.AllocationRequestDataImpl"],
    [72, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: FixingOrderRequestDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.base = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clientCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.comment = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.comment2 = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.externalClientReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.fixedCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.markup = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.nonBase = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.orderId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.OrderType = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.orderType = <CubiqTS.OrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.product = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: CubiqTS.RequestOrderType = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.requestOrderType = <CubiqTS.RequestOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(24),
            streamin,
          );
          encodable.stpHold = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameter> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.strategyParameters = <Array<CubiqTS.StrategyParameter>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.traderGroup = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.tradingChannel = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(32),
            streamin,
          );
          encodable.isPrivateOrder = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(36),
            streamin,
          );
          encodable.useDefaultClientDataFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(37),
            streamin,
          );
          encodable.clientContactIds = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: Array<CubiqTS.CustomValue> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(40),
            streamin,
          );
          encodable.customValues = <Array<CubiqTS.CustomValue>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(41),
            streamin,
          );
          encodable.markupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 45: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyParameter> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(45),
            streamin,
          );
          encodable.passthroughParameters = <Array<CubiqTS.StrategyParameter>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 48: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(48),
            streamin,
          );
          encodable.oboClient = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 49: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(49),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 50: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(50),
            streamin,
          );
          encodable.orderRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 51: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(51),
            streamin,
          );
          encodable.autoForwardPricing = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 60: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(60),
            streamin,
          );
          encodable.fixedAmount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 61: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(61),
            streamin,
          );
          encodable.fixingDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 62: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(62),
            streamin,
          );
          encodable.fixingSource = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 63: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(63),
            streamin,
          );
          encodable.tenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 64: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(64),
            streamin,
          );
          encodable.valueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 65: {
          /*Object encoding*/
          let val: CubiqTS.OrderIntent = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(65),
            streamin,
          );
          encodable.clientIntent = <CubiqTS.OrderIntent>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 66: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(66),
            streamin,
          );
          encodable.swapFixedAmount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 67: {
          /*Object encoding*/
          let val: CubiqTS.StandardTime = this.baseEncoder.readObject(
            true,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(67),
            streamin,
          );
          encodable.fixingTime = <CubiqTS.StandardTime>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 68: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(68),
            streamin,
          );
          encodable.swapTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 69: {
          /*Object encoding*/
          let val: CubiqTS.StandardDate = this.baseEncoder.readObject(
            true,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(69),
            streamin,
          );
          encodable.swapValueDate = <CubiqTS.StandardDate>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 70: {
          /*Object encoding*/
          let val: Array<CubiqTS.AllocationRequestData> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(70),
            streamin,
          );
          encodable.allocations = <Array<CubiqTS.AllocationRequestData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 71: {
          /*Object encoding*/
          let val: Array<CubiqTS.AllocationRequestData> = this.baseEncoder.readObject(
            false,
            true,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(71),
            streamin,
          );
          encodable.farAllocations = <Array<CubiqTS.AllocationRequestData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 72: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            JAVA_OBJECT_NOTENCODABLE,
            SINGLE_OBJECT,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(72),
            streamin,
          );
          encodable.fwdNettingId = val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingOrderRequestDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,FixingOrderRequestDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return FixingOrderRequestDataImplEncoder.fidTypeMap.has(fid);
  }
}
